import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import { EPipelineSummaryColumns } from "@frameworks/salesjourney/components/Home/HomeDashBoard/HomeSalesTable";
export var nrDataMapper = function (data) {
    var nrDataEntity = {
        nrDataList: [],
        totalData: [],
        totalClientCountData: [],
        totalDataLst: [],
    };
    var productList = [], nrDataMainEntityList = [];
    var nrDataTotal = {
        totalPipeline: 0,
        totalOrderValue: 0,
        totalRealised: 0,
        totalInprocess: 0,
        totalNotConverted: 0,
        totalExpired: 0,
        totalPartnerPipeline: 0,
        totalPartnerRemaining: 0,
        totalPartnerInProcess: 0,
        totalPartnerNotConverted: 0,
        totalPartnerConverted: 0,
        totalOfTotalPipeline: 0,
    };
    var nrTotalClientTotal = {
        totalPipelineCount: 0,
        totalInProcessCount: 0,
        totalNotConvertdCount: 0,
        totalOrderCount: 0,
        totalRealisedCount: 0,
        totalExpiredCount: 0,
        totalPartnerPipelineCount: 0,
        totalPartnerRemainingCount: 0,
        totalPartnerInProcessCount: 0,
        totalPartnerNotConvertedCount: 0,
        totalPartnerConvertedCount: 0,
        totalClientCount: 0,
    };
    if (data && data.length > 0) {
        data.map(function (record) {
            if (!productList.includes(record.product)) {
                productList.push(record.product);
                var nrDataMainRecord = {
                    type: record.product,
                    productId: record.productId,
                    isCategory: false,
                    pipeline: 0,
                    order: 0,
                    realised: 0,
                    inprocess: 0,
                    notConverted: 0,
                    pipelineCount: 0,
                    orderValueCount: 0,
                    realisedCount: 0,
                    inprocessCount: 0,
                    notConvertedCount: 0,
                    expired: 0,
                    expiredCount: 0,
                    data: [],
                    partnerPipeline: 0,
                    remainingPartnerPipeline: 0,
                    partnerInProcess: 0,
                    partnerNotConverted: 0,
                    partnerPipelineCount: 0,
                    remainingPartnerPipelineCount: 0,
                    partnerInProcessCount: 0,
                    partnerNotConvertedCount: 0,
                    partnerConveted: 0,
                    partnerConvetedCount: 0,
                    totalPipeline: 0,
                    totalClient: 0,
                };
                nrDataMainEntityList.push(nrDataMainRecord);
            }
            // let nrData: INRDataSubEntity = {
            //   type: record.product,
            //   pipeline:0,
            //   order: 0,
            //   realised: 0,
            // };
            // nrDataList.push(nrData);
        });
        nrDataMainEntityList = nrDataMainEntityList.map(function (record) {
            var nrDataSubEntityList = [];
            data
                .filter(function (item) { return item.product === record.type; })
                .map(function (subRecord) {
                var nrDataSubEntity = {
                    type: subRecord.category,
                    pipeline: subRecord.pipeline,
                    isCategory: true,
                    order: subRecord.orderValue,
                    realised: subRecord.realised,
                    productId: subRecord.productId,
                    categoryId: subRecord.categoryId,
                    inprocess: subRecord.inprocess,
                    notConverted: subRecord.notConverted,
                    pipelineCount: subRecord.pipelineCount,
                    orderValueCount: subRecord.orderValueCount,
                    realisedCount: subRecord.realisedCount,
                    inprocessCount: subRecord.inprocessCount,
                    notConvertedCount: subRecord.notConvertedCount,
                    categoryName: subRecord.category,
                    expired: subRecord.expired,
                    expiredCount: subRecord.expiredCount,
                    partnerPipeline: subRecord.partnerPipeline,
                    remainingPartnerPipeline: subRecord.remainingPipeline,
                    partnerInProcess: subRecord.partnerinProcess,
                    partnerNotConverted: subRecord.partnernonConveted,
                    partnerInProcessCount: subRecord.partnerinProcessCount,
                    partnerNotConvertedCount: subRecord.partnernonConvetedCount,
                    partnerPipelineCount: subRecord.partnerPipelineCount,
                    remainingPartnerPipelineCount: subRecord.remainingPipelineCount,
                    partnerConveted: subRecord.partnerConveted,
                    partnerConvetedCount: subRecord.partnerConvetedCount,
                    totalPipeline: subRecord.totalPipeline,
                    totalClient: subRecord.totalClient,
                };
                record.pipeline += parseInt(subRecord.pipeline.toString());
                record.order += subRecord.orderValue;
                record.realised += subRecord.realised;
                record.inprocess += subRecord.inprocess;
                record.notConverted += subRecord.notConverted;
                record.pipelineCount += subRecord.pipelineCount;
                record.orderValueCount += subRecord.orderValueCount;
                record.realisedCount += subRecord.realisedCount;
                record.inprocessCount += subRecord.inprocessCount;
                record.notConvertedCount += subRecord.notConvertedCount;
                record.expired += subRecord.expired;
                record.expiredCount += subRecord.expiredCount;
                record.partnerPipeline += subRecord.partnerPipeline;
                record.remainingPartnerPipeline +=
                    subRecord.remainingPipeline;
                record.partnerInProcess += subRecord.partnerinProcess;
                record.partnerNotConverted +=
                    subRecord.partnernonConveted;
                record.partnerInProcessCount +=
                    subRecord.partnerinProcessCount;
                record.partnerNotConvertedCount +=
                    subRecord.partnernonConvetedCount;
                record.partnerPipelineCount +=
                    subRecord.partnerPipelineCount;
                record.remainingPartnerPipelineCount +=
                    subRecord.remainingPipelineCount;
                record.partnerConveted += subRecord.partnerConveted;
                record.partnerConvetedCount +=
                    subRecord.partnerConvetedCount;
                record.totalPipeline += subRecord.totalPipeline;
                record.totalClient += subRecord.totalClient;
                if (Number(subRecord.realised) !== 0 ||
                    Number(subRecord.orderValue) !== 0 ||
                    Number(subRecord.pipeline) !== 0 ||
                    Number(subRecord.inprocess) !== 0 ||
                    Number(subRecord.notConverted) !== 0 ||
                    Number(subRecord.expired) !== 0 ||
                    Number(subRecord.partnerPipeline) !== 0 ||
                    Number(subRecord.remainingPipeline) !== 0 ||
                    Number(subRecord.partnerinProcess) !== 0 ||
                    Number(subRecord.partnernonConveted) !== 0 ||
                    Number(subRecord.partnerConveted) !== 0 ||
                    Number(subRecord.totalPipeline) !== 0)
                    nrDataSubEntityList.push(nrDataSubEntity);
                //return subRecord;
            });
            record.data = nrDataSubEntityList;
            nrDataTotal.totalOrderValue += parseInt(record.order.toString());
            nrDataTotal.totalPipeline += parseInt(record.pipeline.toString());
            nrDataTotal.totalRealised += parseInt(record.realised.toString());
            nrDataTotal.totalInprocess += parseInt(record.inprocess.toString());
            nrDataTotal.totalNotConverted += parseInt(record.notConverted.toString());
            nrDataTotal.totalExpired += parseInt(record.expired.toString());
            nrDataTotal.totalPartnerInProcess += parseInt(record.partnerInProcess.toString());
            nrDataTotal.totalPartnerNotConverted += parseInt(record.partnerNotConverted.toString());
            nrDataTotal.totalPartnerRemaining += parseInt(record.remainingPartnerPipeline.toString());
            nrDataTotal.totalPartnerPipeline += parseInt(record.partnerPipeline.toString());
            nrDataTotal.totalPartnerConverted += parseInt(record.partnerConveted.toString());
            nrDataTotal.totalOfTotalPipeline += parseInt(record.totalPipeline.toString());
            nrTotalClientTotal.totalInProcessCount += parseInt(record.inprocessCount.toString());
            nrTotalClientTotal.totalNotConvertdCount += parseInt(record.notConvertedCount.toString());
            nrTotalClientTotal.totalOrderCount += parseInt(record.orderValueCount.toString());
            nrTotalClientTotal.totalPipelineCount += parseInt(record.pipelineCount.toString());
            nrTotalClientTotal.totalRealisedCount += parseInt(record.realisedCount.toString());
            nrTotalClientTotal.totalExpiredCount += parseInt(record.expiredCount.toString());
            nrTotalClientTotal.totalPartnerInProcessCount += parseInt(record.partnerInProcessCount.toString());
            nrTotalClientTotal.totalPartnerNotConvertedCount += parseInt(record.partnerNotConvertedCount.toString());
            nrTotalClientTotal.totalPartnerRemainingCount += parseInt(record.remainingPartnerPipelineCount.toString());
            nrTotalClientTotal.totalPartnerPipelineCount += parseInt(record.partnerPipelineCount.toString());
            nrTotalClientTotal.totalPartnerConvertedCount += parseInt(record.partnerConvetedCount.toString());
            nrTotalClientTotal.totalClientCount += parseInt(record.totalClient.toString());
            return record;
        });
        if (!loginDI.login.getIsRMPartnerFRM().isRM) {
            nrDataEntity.totalDataLst.push({
                totalDataKey: nrDataTotal.totalOfTotalPipeline,
                totalClientDataKey: nrTotalClientTotal.totalClientCount,
                columnName: EPipelineSummaryColumns.TotalClientPartner,
            });
            nrDataEntity.totalDataLst.push({
                totalDataKey: nrDataTotal.totalPartnerPipeline,
                totalClientDataKey: nrTotalClientTotal.totalPartnerPipelineCount,
                columnName: EPipelineSummaryColumns.Partner,
            });
            nrDataEntity.totalDataLst.push({
                totalDataKey: nrDataTotal.totalPartnerRemaining,
                totalClientDataKey: nrTotalClientTotal.totalPartnerRemainingCount,
                columnName: EPipelineSummaryColumns.Remaining,
            });
            // nrDataEntity.totalDataLst.push({
            //   totalDataKey: nrDataTotal.totalPartnerConverted,
            //   totalClientDataKey: nrTotalClientTotal.totalPartnerConvertedCount,
            // });
            // nrDataEntity.totalDataLst.push({
            //   totalDataKey: nrDataTotal.totalPartnerInProcess,
            //   totalClientDataKey: nrTotalClientTotal.totalPartnerInProcessCount,
            // });
            nrDataEntity.totalDataLst.push({
                totalDataKey: nrDataTotal.totalPartnerNotConverted,
                totalClientDataKey: nrTotalClientTotal.totalPartnerNotConvertedCount,
                columnName: EPipelineSummaryColumns.NotConverted,
            });
        }
        nrDataEntity.totalDataLst.push({
            totalDataKey: nrDataTotal.totalPipeline,
            totalClientDataKey: nrTotalClientTotal.totalPipelineCount,
            columnName: EPipelineSummaryColumns.ClientTotal,
        });
        nrDataEntity.totalDataLst.push({
            totalDataKey: nrDataTotal.totalInprocess,
            totalClientDataKey: nrTotalClientTotal.totalInProcessCount,
            columnName: EPipelineSummaryColumns.InprocessPipeline,
        });
        nrDataEntity.totalDataLst.push({
            totalDataKey: nrDataTotal.totalNotConverted,
            totalClientDataKey: nrTotalClientTotal.totalNotConvertdCount,
            columnName: EPipelineSummaryColumns.NotConvertedPipeline,
        });
        nrDataEntity.totalDataLst.push({
            totalDataKey: nrDataTotal.totalExpired,
            totalClientDataKey: nrTotalClientTotal.totalExpiredCount,
            columnName: EPipelineSummaryColumns.Expired,
        });
        nrDataEntity.totalDataLst.push({
            totalDataKey: nrDataTotal.totalOrderValue,
            totalClientDataKey: nrTotalClientTotal.totalOrderCount,
            columnName: EPipelineSummaryColumns.ConvertedPipeline,
        });
        nrDataEntity.totalDataLst.push({
            totalDataKey: nrDataTotal.totalRealised,
            totalClientDataKey: nrTotalClientTotal.totalRealisedCount,
            columnName: EPipelineSummaryColumns.OrderValue,
        });
        nrDataEntity.nrDataList = nrDataMainEntityList;
    }
    return nrDataEntity;
};
